export function getInitials(name: string): string {
  if (!name) return '';
  const trimmed = name.trim();
  const parts = trimmed.split(/\s+/).filter(Boolean);

  if (parts.length === 0) return '';

  const firstLetterInitial = parts[0][0];

  if (parts.length >= 2) {
    const lastLetterInitial = parts[parts.length - 1][0];
    return (firstLetterInitial + lastLetterInitial).toUpperCase();
  }

  return firstLetterInitial.toUpperCase();
}
